import { ReactNode } from 'react';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

export default function ThemeLocalization({ children }: Props) {
  return <>{children}</>;
}
